<template lang="">
  <b-modal
    id="ModalTicketID"
    @close="close"
    size="xl"
    hide-footer
    hide-header
    body-class="p-0 dynamic-modal-border"
    modal-class="modal--class--detail"
    centered>
    <div class="modal--class--header">
      <b-button class="close--button" @click="close" title="Cerrar" variant="link"><feather-icon size="25" stroke-width="2" icon="XIcon"/></b-button>
    </div>
    <detail-ticket-vue
      v-if="!!ticketId"
      :ticketIdModal="ticketId"
      :colorArray="colorArray"
      :isModal="true"
      @dataStyleModal="dataStyleModal"
    ></detail-ticket-vue>
  </b-modal>
</template>
<script>
import DetailTicketVue from '@/views/modules/tickets/components/Detail/DetailTicket.vue'
export default {
  props: ['ticketId', 'colorArray'],
  components: { DetailTicketVue },
  data() {
    return {
      viewDetail: false,
      modalBorderColor: ''
    }
  },
  computed: {
  },
  methods: {
    close() {
      this.$bvModal.hide('ModalTicketID')
      this.$emit('resetTicketId', true)
    },
    dataStyleModal(data) {
      this.modalBorderColor = data.border_color || 'blue'
      this.setBorderColor(data.border_color || 'white')
    },
    setBorderColor(color) {
      const root = document.documentElement
      root.style.setProperty('--border-color-detail-ticket', color)
    }
  }
}
</script>
<style lang="scss" >
  :root {
    --border-color-detail-ticket: blue;
  }
  .modal-open .modal--class--detail {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow: hidden;
  }

  .modal-open .modal--class--detail,
  .modal--class--detail .detail--ticket--container {
    max-height: 98vh;
    padding-bottom: 10px;
  }

  .modal--class--detail .modal-dialog {
    overflow: hidden;
    border-radius: 10px;
    max-height: 95vh;
  }

  .dynamic-modal-border {
    border-left: 15px solid var(--border-color-detail-ticket);
    max-height: 95vh;
  }
  .modal--class--header {
    position: absolute;
    z-index: 1;
    right: 20px;
    top: 20px;
    .close--button {
      padding: 0;
      color: #00000080;
    }
  }
</style>
